export default "__VITE_ASSET__BIcj1Stl__"